import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home/Home'
import Login from "@/views/Login/Login";
import store from "@/store";
import config from "@/config";
import StorePanel from "@/views/StorePanel/StorePanel";
// import metamask from "@/lib/metamask";
import StoreProfileInfo from "@/views/StorePanel/Children/ProfileInfo";
import StoreProfileEdit from "@/views/StorePanel/Children/ProfileEdit";
import Purchasable from "@/views/StorePanel/Children/Purchasable";
import PurchasableCreate from "@/views/StorePanel/Children/PurchasableCreate";
import Redeemable from "@/views/StorePanel/Children/Redeemable";
import RedeemableCreate from "@/views/StorePanel/Children/RedeemableCreate";
import ReceivingRecord from "@/views/StorePanel/Children/ReceivingRecord";
import Payment from "@/views/Payment/Payment";
import Proposal from "@/views/StorePanel/Children/Proposal";
import ProposalCreate from "@/views/StorePanel/Children/ProposalCreate";
import StoreSearch from "@/views/StoreSearch/StoreSearch";
import Store from "@/views/Store/Store";
import Stablecoin from "@/views/Faucet/Stablecoin";
import metamask from "@/lib/metamask";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    component: Home,
    redirect: () => {
      return { name: 'storeSearch' }
    },
    meta: {requireAuth: true},
    children: [
      {
        path: 'stores',
        name: 'storeSearch',
        component: StoreSearch,
        meta: {requireAuth: true},
      },
      {
        path: 'store',
        name: 'store',
        component: Store,
        meta: {requireAuth: true},
      },
      {
        path: 'panel',
        name: 'panel',
        component: StorePanel,
        meta: {requireAuth: true},
        children: [
          {
            path: "profile",
            name: "storeProfileInfo",
            component: StoreProfileInfo,
            meta: {requireAuth: true}
          },
          {
            path: "profile/edit",
            name: "storeProfileEdit",
            component: StoreProfileEdit,
            meta: {requireAuth: true}
          },
          {
            path: "purchasable",
            name: "storePurchasable",
            component: Purchasable,
            meta: {requireAuth: true}
          },
          {
            path: "purchasable/create",
            name: "storePurchasableCreate",
            component: PurchasableCreate,
            meta: {requireAuth: true}
          },
          {
            path: "redeemable",
            name: "storeRedeemable",
            component: Redeemable,
            meta: {requireAuth: true}
          },
          {
            path: "redeemable/create",
            name: "storeRedeemableCreate",
            component: RedeemableCreate,
            meta: {requireAuth: true}
          },
          {
            path: "receiving",
            name: "receivingRecord",
            component: ReceivingRecord,
            meta: {requireAuth: true}
          },
          {
            path: "proposal",
            name: "proposal",
            component: Proposal,
            meta: {requireAuth: true}
          },
          {
            path: "proposal/create",
            name: "proposalCreate",
            component: ProposalCreate,
            meta: {requireAuth: true}
          }
        ]
      },
      {
        path: "payment",
        name: "payment",
        component: Payment,
        meta: {requireAuth: true}
      },
      {
        path: "stablecoin/faucet",
        name: "stablecoinFaucet",
        component: Stablecoin,
        meta: {requireAuth: true}
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {

  if (to.meta.requireAuth) {

    const authToken = localStorage.getItem('authToken')

    //check whether auth token expired
    if (authToken) {
      //get the timestamp of signing the login msg
      const msg = JSON.parse(authToken).loginMsg
      let searchString = "Timestamp:"
      let index = msg.indexOf(searchString) + searchString.length + 1
      let endIndex = msg.slice(index).indexOf('\n')

      const timestamp = parseInt(msg.substring(index, index + endIndex))

      //clean the storage when login session expired
      if ((new Date().getTime() - timestamp) > config.commonConfig.authTimeout){
        localStorage.removeItem('authToken')
        Vue.notify({
          type: 'error',
          text: 'Login session expired'
        })
      }
    }

    //init logged in account
    if (!store.state.loggedInAccount) {
      try {
        await metamask.wallet.connectWallet()
      } catch (e) {
        next({
          name: 'login'
        })
      }
    }

    //direct user to login page with invalid auth condition
    if (!localStorage.getItem('authToken') || !store.state.loggedInAccount){
      next({
        name: 'login'
      })
    }


    // //init loggedIn Account
    // if (authToken && !store.state.loggedInAccount) {
    //   metamask.wallet.connectWallet()
    // }

    //authorized to go to the page
    next();
  } else {
    next();
  }
})

export default router
